import React from 'react';
import { AlertCircle } from '@finect/tabular-icons/alertCircle';
import { CheckCircle } from '@finect/tabular-icons/checkCircle';
import { Info } from '@finect/tabular-icons/info';
import { XCircle } from '@finect/tabular-icons/xCircle';
import { Inner, Title, Subtitle, IconBlock, ContentBlock, Line } from './partials';
var ICONS = {
  error: XCircle,
  warning: AlertCircle,
  info: Info,
  success: CheckCircle
};
var SIZES = {
  small: {
    lineWidth: '3px',
    icon: 20,
    iconMargin: '9px'
  },
  large: {
    lineWidth: '5px',
    icon: 28,
    iconMargin: '14px'
  }
};
export var Alert = function Alert(_ref) {
  var type = _ref.type,
    title = _ref.title,
    subtitle = _ref.subtitle,
    children = _ref.children,
    _ref$withIcon = _ref.withIcon,
    withIcon = _ref$withIcon === void 0 ? true : _ref$withIcon,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'large' : _ref$size;
  var Icon = ICONS[type];
  var content = children || subtitle || null;
  var sizeParams = SIZES[size] || SIZES.large;
  return React.createElement(Inner, {
    sizeParams: sizeParams
  }, React.createElement(Line, {
    type: type,
    withIcon: Boolean(withIcon)
  }), withIcon && Icon ? React.createElement(IconBlock, {
    type: type
  }, React.createElement(Icon, {
    size: sizeParams.icon
  })) : null, React.createElement(ContentBlock, null, title ? React.createElement(Title, null, title) : null, content ? React.createElement(Subtitle, null, content) : null));
};